export const BASE_URL =
  window.location.href.indexOf("localhost") > -1
    ? "http://localhost:3333/api/v1"
    : "https://backend.doadesignz.com/api/v1";
export const SOCKET_URL =
  window.location.href.indexOf("localhost") > -1
    ? "http://localhost:3333/"
    : "https://backend.doadesignz.com/";
export const GAUTH_CLIENT_KEY =
  "163014960513-gaekhuid8u7fhl68p19rthghe4lr7v4f.apps.googleusercontent.com";
export const PAYSTACK_PUBLIC_KEY =
  "pk_test_4a4b3f379b34921c28d5b9fb508ec89860afda36";
